export var onDocumentLoad = function (func) {
    var arr = (window.ON_DOCUMENT_LOAD = window.ON_DOCUMENT_LOAD || []);
    if (func)
        arr.push(func);
    document.addEventListener('DOMContentLoaded', function (event) {
        while (arr.length > 0) {
            var f = arr.shift();
            try {
                f === null || f === void 0 ? void 0 : f();
            }
            catch (e) {
                console.error(e);
            }
        }
    });
};
export default onDocumentLoad;
